// ─── Country & State Data ──────────────────────────────────────────────────────

export const COUNTRY_DATA = {
  US: {
    name: "United States", flag: "🇺🇸", stateLabel: "State",
    zipLabel: "ZIP Code", zipPattern: /^\d{5}(-\d{4})?$/, zipPlaceholder: "e.g. 90210",
    states: [
      { name: "Alabama", code: "AL" }, { name: "Alaska", code: "AK" },
      { name: "Arizona", code: "AZ" }, { name: "Arkansas", code: "AR" },
      { name: "California", code: "CA" }, { name: "Colorado", code: "CO" },
      { name: "Connecticut", code: "CT" }, { name: "Delaware", code: "DE" },
      { name: "Florida", code: "FL" }, { name: "Georgia", code: "GA" },
      { name: "Hawaii", code: "HI" }, { name: "Idaho", code: "ID" },
      { name: "Illinois", code: "IL" }, { name: "Indiana", code: "IN" },
      { name: "Iowa", code: "IA" }, { name: "Kansas", code: "KS" },
      { name: "Kentucky", code: "KY" }, { name: "Louisiana", code: "LA" },
      { name: "Maine", code: "ME" }, { name: "Maryland", code: "MD" },
      { name: "Massachusetts", code: "MA" }, { name: "Michigan", code: "MI" },
      { name: "Minnesota", code: "MN" }, { name: "Mississippi", code: "MS" },
      { name: "Missouri", code: "MO" }, { name: "Montana", code: "MT" },
      { name: "Nebraska", code: "NE" }, { name: "Nevada", code: "NV" },
      { name: "New Hampshire", code: "NH" }, { name: "New Jersey", code: "NJ" },
      { name: "New Mexico", code: "NM" }, { name: "New York", code: "NY" },
      { name: "North Carolina", code: "NC" }, { name: "North Dakota", code: "ND" },
      { name: "Ohio", code: "OH" }, { name: "Oklahoma", code: "OK" },
      { name: "Oregon", code: "OR" }, { name: "Pennsylvania", code: "PA" },
      { name: "Rhode Island", code: "RI" }, { name: "South Carolina", code: "SC" },
      { name: "South Dakota", code: "SD" }, { name: "Tennessee", code: "TN" },
      { name: "Texas", code: "TX" }, { name: "Utah", code: "UT" },
      { name: "Vermont", code: "VT" }, { name: "Virginia", code: "VA" },
      { name: "Washington", code: "WA" }, { name: "West Virginia", code: "WV" },
      { name: "Wisconsin", code: "WI" }, { name: "Wyoming", code: "WY" },
      { name: "District of Columbia", code: "DC" },
    ],
  },
  CA: {
    name: "Canada", flag: "🇨🇦", stateLabel: "Province / Territory",
    zipLabel: "Postal Code", zipPattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/, zipPlaceholder: "e.g. K1A 0B1",
    states: [
      { name: "Alberta", code: "AB" }, { name: "British Columbia", code: "BC" },
      { name: "Manitoba", code: "MB" }, { name: "New Brunswick", code: "NB" },
      { name: "Newfoundland and Labrador", code: "NL" }, { name: "Northwest Territories", code: "NT" },
      { name: "Nova Scotia", code: "NS" }, { name: "Nunavut", code: "NU" },
      { name: "Ontario", code: "ON" }, { name: "Prince Edward Island", code: "PE" },
      { name: "Quebec", code: "QC" }, { name: "Saskatchewan", code: "SK" },
      { name: "Yukon", code: "YT" },
    ],
  },
  AU: {
    name: "Australia", flag: "🇦🇺", stateLabel: "State / Territory",
    zipLabel: "Postcode", zipPattern: /^\d{4}$/, zipPlaceholder: "e.g. 2000",
    states: [
      { name: "Australian Capital Territory", code: "ACT" }, { name: "New South Wales", code: "NSW" },
      { name: "Northern Territory", code: "NT" }, { name: "Queensland", code: "QLD" },
      { name: "South Australia", code: "SA" }, { name: "Tasmania", code: "TAS" },
      { name: "Victoria", code: "VIC" }, { name: "Western Australia", code: "WA" },
    ],
  },
  JP: {
    name: "Japan", flag: "🇯🇵", stateLabel: "Prefecture",
    zipLabel: "Postal Code", zipPattern: /^\d{3}-?\d{4}$/, zipPlaceholder: "e.g. 100-0001",
    states: [
      { name: "Aichi", code: "Aichi" }, { name: "Akita", code: "Akita" },
      { name: "Aomori", code: "Aomori" }, { name: "Chiba", code: "Chiba" },
      { name: "Ehime", code: "Ehime" }, { name: "Fukui", code: "Fukui" },
      { name: "Fukuoka", code: "Fukuoka" }, { name: "Fukushima", code: "Fukushima" },
      { name: "Gifu", code: "Gifu" }, { name: "Gunma", code: "Gunma" },
      { name: "Hiroshima", code: "Hiroshima" }, { name: "Hokkaido", code: "Hokkaido" },
      { name: "Hyogo", code: "Hyogo" }, { name: "Ibaraki", code: "Ibaraki" },
      { name: "Ishikawa", code: "Ishikawa" }, { name: "Iwate", code: "Iwate" },
      { name: "Kagawa", code: "Kagawa" }, { name: "Kagoshima", code: "Kagoshima" },
      { name: "Kanagawa", code: "Kanagawa" }, { name: "Kochi", code: "Kochi" },
      { name: "Kumamoto", code: "Kumamoto" }, { name: "Kyoto", code: "Kyoto" },
      { name: "Mie", code: "Mie" }, { name: "Miyagi", code: "Miyagi" },
      { name: "Miyazaki", code: "Miyazaki" }, { name: "Nagano", code: "Nagano" },
      { name: "Nagasaki", code: "Nagasaki" }, { name: "Nara", code: "Nara" },
      { name: "Niigata", code: "Niigata" }, { name: "Oita", code: "Oita" },
      { name: "Okayama", code: "Okayama" }, { name: "Okinawa", code: "Okinawa" },
      { name: "Osaka", code: "Osaka" }, { name: "Saga", code: "Saga" },
      { name: "Saitama", code: "Saitama" }, { name: "Shiga", code: "Shiga" },
      { name: "Shimane", code: "Shimane" }, { name: "Shizuoka", code: "Shizuoka" },
      { name: "Tochigi", code: "Tochigi" }, { name: "Tokushima", code: "Tokushima" },
      { name: "Tokyo", code: "Tokyo" }, { name: "Tottori", code: "Tottori" },
      { name: "Toyama", code: "Toyama" }, { name: "Wakayama", code: "Wakayama" },
      { name: "Yamagata", code: "Yamagata" }, { name: "Yamaguchi", code: "Yamaguchi" },
      { name: "Yamanashi", code: "Yamanashi" },
    ],
  },
  GB: {
    name: "United Kingdom", flag: "🇬🇧", stateLabel: "Region / Country",
    zipLabel: "Postcode", zipPattern: /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i, zipPlaceholder: "e.g. SW1A 1AA",
    states: [
      { name: "England", code: "ENG" }, { name: "Scotland", code: "SCT" },
      { name: "Wales", code: "WLS" }, { name: "Northern Ireland", code: "NIR" },
    ],
  },
  IE: {
    name: "Republic of Ireland", flag: "🇮🇪", stateLabel: "County",
    zipLabel: "Eircode", zipPattern: /^[A-Z]\d{2}[\s]?[A-Z0-9]{4}$/i, zipPlaceholder: "e.g. D02 X285",
    states: [
      { name: "Carlow", code: "CW" }, { name: "Cavan", code: "CN" },
      { name: "Clare", code: "CE" }, { name: "Cork", code: "CO" },
      { name: "Donegal", code: "DL" }, { name: "Dublin", code: "D" },
      { name: "Galway", code: "G" }, { name: "Kerry", code: "KY" },
      { name: "Kildare", code: "KE" }, { name: "Kilkenny", code: "KK" },
      { name: "Laois", code: "LS" }, { name: "Leitrim", code: "LM" },
      { name: "Limerick", code: "LK" }, { name: "Longford", code: "LD" },
      { name: "Louth", code: "LH" }, { name: "Mayo", code: "MO" },
      { name: "Meath", code: "MH" }, { name: "Monaghan", code: "MN" },
      { name: "Offaly", code: "OY" }, { name: "Roscommon", code: "RN" },
      { name: "Sligo", code: "SO" }, { name: "Tipperary", code: "TA" },
      { name: "Waterford", code: "WD" }, { name: "Westmeath", code: "WH" },
      { name: "Wexford", code: "WX" }, { name: "Wicklow", code: "WW" },
    ],
  },
  FR: {
    name: "France", flag: "🇫🇷", stateLabel: "Region",
    zipLabel: "Postal Code", zipPattern: /^\d{5}$/, zipPlaceholder: "e.g. 75001",
    states: [
      { name: "Auvergne-Rhône-Alpes", code: "ARA" }, { name: "Bourgogne-Franche-Comté", code: "BFC" },
      { name: "Bretagne", code: "BRE" }, { name: "Centre-Val de Loire", code: "CVL" },
      { name: "Corse", code: "COR" }, { name: "Grand Est", code: "GES" },
      { name: "Guadeloupe", code: "GUA" }, { name: "Guyane", code: "GUY" },
      { name: "Hauts-de-France", code: "HDF" }, { name: "Île-de-France", code: "IDF" },
      { name: "La Réunion", code: "REU" }, { name: "Martinique", code: "MTQ" },
      { name: "Mayotte", code: "MAY" }, { name: "Normandie", code: "NOR" },
      { name: "Nouvelle-Aquitaine", code: "NAQ" }, { name: "Occitanie", code: "OCC" },
      { name: "Pays de la Loire", code: "PDL" }, { name: "Provence-Alpes-Côte d'Azur", code: "PAC" },
    ],
  },
  ES: {
    name: "Spain", flag: "🇪🇸", stateLabel: "Autonomous Community",
    zipLabel: "Postal Code", zipPattern: /^\d{5}$/, zipPlaceholder: "e.g. 28001",
    states: [
      { name: "Andalusia", code: "AN" }, { name: "Aragon", code: "AR" },
      { name: "Asturias", code: "AS" }, { name: "Balearic Islands", code: "IB" },
      { name: "Basque Country", code: "PV" }, { name: "Canary Islands", code: "CN" },
      { name: "Cantabria", code: "CB" }, { name: "Castile and León", code: "CL" },
      { name: "Castilla-La Mancha", code: "CM" }, { name: "Catalonia", code: "CT" },
      { name: "Ceuta", code: "CE" }, { name: "Extremadura", code: "EX" },
      { name: "Galicia", code: "GA" }, { name: "La Rioja", code: "RI" },
      { name: "Madrid", code: "MD" }, { name: "Melilla", code: "ML" },
      { name: "Murcia", code: "MC" }, { name: "Navarre", code: "NC" },
      { name: "Valencia", code: "VC" },
    ],
  },
};